import React from "react";

import { TabType, MOBILE } from "@constants";
import { lowerCaseFirstLetter } from "@utilities";

import { FiltersProps } from "../../../types";

import FormControl from "../FormControl";
import FilterCheckbox from "../FilterCheckbox";

/* eslint-disable jsx-a11y/label-has-associated-control */

type FiltersMobileFormBranchesProps = {
  type: TabType;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & FiltersProps;

const FiltersMobileFormBranches: React.FC<FiltersMobileFormBranchesProps> = ({
  filters,
  type,
  handleOnChange,
}) => {
  const checkboxesArr = filters.slice(0, 1); // haveCashServiceArr
  const openingHoursArr = filters[1].items;
  const handicapedArr = filters[2].items;
  const forCompaniesArr = filters[3].items;
  const servicesArr = filters[4].items;

  const formData = [
    ...checkboxesArr,
    ...openingHoursArr,
    ...handicapedArr,
    ...forCompaniesArr,
    ...servicesArr,
  ];

  return (
    <form className={`form-filters-${MOBILE}-${type}`}>
      {formData.map((item) => {
        const itemValue = lowerCaseFirstLetter(item.value);

        return (
          <FormControl key={itemValue}>
            <FilterCheckbox
              type={type}
              id={`${MOBILE}-${itemValue}`}
              name={itemValue}
              checkboxValue={itemValue}
              defaultChecked={item.isChecked}
              label={item.name}
              handleOnChange={handleOnChange}
            />
          </FormControl>
        );
      })}
    </form>
  );
};

export default FiltersMobileFormBranches;
